import React, { useEffect } from 'react'
import {
  Row,
  Col,
  PAYPAL_THEME,
  Button,
  Link,
  HeadingText,
  BodyText,
} from '@paypalcorp/pp-react'
import { Link as RouterLink } from 'react-router-dom'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import Spinner from '../../../components/common/spinner'
import { CopyToClipboardButtonBanner } from '../../../components/common/copy-to-clipboard-button-banner'
import { recordDynamicEvent } from '../../../components/common/analytics/utils'
import TextTwoLines from '../../../components/common/text-two-lines'
import { saveBannerProgress } from '../../../utils/session-utils'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { getUserType } from '../../../utils/user-utils'
import ToggleHiddenSecret from '../../../components/common/hidden-client-secret'

function AppCredentials({ setBannerPage, env }) {
  const { sysColorBackgroundMediumContrast } = PAYPAL_THEME

  const {
    user,
    csrf,
    logger,
    setCurrentEnvironment,
    currentAppValue,
    clientId,
    clientSecret,
    currentAppName,
    homePageDataLoading,
    setCurrentBannerStep,
    isWebLLSUser,
  } = useApplicationContext()

  useEffect(() => {
    if (homePageDataLoading === undefined || homePageDataLoading === true) {
      return
    }
    const accountType = getUserType(user)
    if (isWebLLSUser && accountType === 'BUSINESS') {
      setCurrentEnvironment('sandbox')
    } else {
      setCurrentEnvironment(env)
    }
  }, [homePageDataLoading])

  return (
    <>
      <Row>
        <Col xs={10} className="banner-title_row">
          <HeadingText size="sm">
            <Message
              id={
                env === 'sandbox'
                  ? 'onboarding-banner.sandboxCredentialsTitle'
                  : 'onboarding-banner.livePaymentsTitle'
              }
            />
          </HeadingText>
        </Col>
      </Row>
      {(homePageDataLoading === undefined || homePageDataLoading === true) && (
        <Spinner size="md" />
      )}

      <>
        {!homePageDataLoading && clientId && (
          <>
            <div className="banner-app-credentials-div">
              <Row>
                <Col>
                  <Row>
                    <Col xs={2}>
                      <BodyText
                        style={{ color: sysColorBackgroundMediumContrast }}
                      >
                        <Message id="onboarding-banner.clientId" />
                      </BodyText>
                    </Col>
                    <Col>
                      <TextTwoLines
                        text={clientId}
                        icon={
                          <CopyToClipboardButtonBanner
                            infoToCopy={clientId}
                            analitycsOrigen="app-credentials-client_id"
                          />
                        }
                      />
                      <br />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col style={{ width: '700px' }}>
                  <Row>
                    <Col xs={2} style={{ width: '100px' }}>
                      <BodyText
                        style={{ color: sysColorBackgroundMediumContrast }}
                      >
                        <Message id="onboarding-banner.liveClientSecret" />
                      </BodyText>
                    </Col>
                    {clientSecret !== undefined ? (
                      <Col>
                        <ToggleHiddenSecret clientSecret={clientSecret} />
                      </Col>
                    ) : (
                      <Col style={{ width: '700px' }}>
                        <Message id="onboarding-banner.disabledClientSecret_1" />
                        <br />
                        <Message id="onboarding-banner.disabledClientSecret_2" />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </div>
            <Row className="banner-manage_api_row">
              <Col>
                <Link
                  to={`/applications/edit/${currentAppValue}?appname=${currentAppName}`}
                  as={RouterLink}
                  onClick={() =>
                    recordDynamicEvent(
                      `onboarding_banner_credentials,click,manage_api_creds_${env}`,
                    )
                  }
                >
                  <BodyText className="banner-manage_api_creds">
                    <Message id="onboarding-banner.manageAPICred" />
                  </BodyText>
                </Link>
              </Col>
            </Row>
            {env === 'live' && (
              <Row>
                <Col>
                  <Button
                    size="md"
                    secondary
                    onClick={() => {
                      const sessionObject = {
                        bannerPage: 5,
                      }
                      saveBannerProgress(csrf, logger, sessionObject)
                      setBannerPage(5)
                      setCurrentBannerStep(sessionObject)
                      recordDynamicEvent(
                        'onboarding_banner_pages,click,done,step5',
                      )
                    }}
                  >
                    <Message id="onboarding-banner.test-payments.done.testing" />
                  </Button>
                </Col>
              </Row>
            )}
            {env === 'sandbox' && (
              <Row>
                <Col>
                  <Button
                    size="md"
                    secondary
                    onClick={() => {
                      const sessionObject = {
                        bannerPage: 3,
                      }
                      saveBannerProgress(csrf, logger, sessionObject)
                      setBannerPage(3)
                      setCurrentBannerStep(sessionObject)
                      recordDynamicEvent(
                        'onboarding_banner_pages,click,next,step3',
                      )
                    }}
                  >
                    <Message id="onboarding-banner.sbCredsNextButton" />
                  </Button>
                </Col>
              </Row>
            )}
          </>
        )}
      </>
    </>
  )
}

export default injectWorldReady(AppCredentials)
